import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as modalActions from 'actions/modalActions';

import PassengerList from 'components/AirlineSeatSelection/PassengerList';
import LinkButton from 'components/LinkButton/LinkButton';
import { AIRLINE_SEAT_LIST } from 'constants/modal';
import { SLIDE_DIRECTION_LEFT } from 'components/Modal/SlideInFromTheSideModal';

/* istanbul ignore next */
const mapStateToProps = state => ({
  bookSeatPrice: state.bookState.getIn(['priceBreakdown', 'airlineSeatPrice']),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  modalActionsBound: bindActionCreators(modalActions, dispatch),
});

export class PassengerListModal extends PureComponent {
  static propTypes = {
    bookSeatPrice: PropTypes.number,
    modalActionsBound: PropTypes.shape({
      toggleModal: PropTypes.func.isRequired,
    }).isRequired,
  };

  openSeatList = (direction, passengerIndex) => {
    const type = passengerIndex !== undefined ? 'passenger' : 'all';
    const selectedPassenger = passengerIndex !== undefined ? passengerIndex : 0;

    this.props.modalActionsBound.toggleModal(AIRLINE_SEAT_LIST, {
      slideInFromTheSide: SLIDE_DIRECTION_LEFT,
      title: 'In-flight Seat Selection',
      type,
      direction,
      passengerIndex: selectedPassenger,
    });
  };

  onCloseClick = (event) => {
    event.preventDefault();
    this.props.modalActionsBound.toggleModal();
  };

  render() {
    const hasSeatsSelected = this.props.bookSeatPrice > 0;

    return (
      <div>
        <PassengerList openSeatList={this.openSeatList} />
        <div className="passenger-list-sub-page__button-wrapper">
          <LinkButton
            onClick={this.onCloseClick}
            color={hasSeatsSelected ? undefined : 'blue'}
            type={hasSeatsSelected ? undefined : 'secondary'}
          >
            { hasSeatsSelected ? 'Done' : 'Close' }
          </LinkButton>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengerListModal);



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/PassengerListModal.jsx
 **/